import Component from '@averyano/core/src/classes/Component';
import GSAP from 'gsap';

// Bands are tiled every 143px (viewBox units). The loop must advance an even
// number of bands so the 2-color gray pattern realigns seamlessly. 10 bands
// (1430) per 25s cycle sets the drift speed.
const PERIOD = 1430;

export default class VisionWaves extends Component {
	constructor() {
		super({
			element: '.vision',
			elements: {
				waves: '.vision__waves',
			},
		});
	}

	create() {
		super.createComponent();
		if (!this.elements.waves) return;

		this.tween = GSAP.to(this.elements.waves, {
			x: PERIOD,
			duration: 25,
			ease: 'none',
			repeat: -1,
		});
	}

	destroy() {
		this.tween?.kill();
		super.destroy();
	}
}
